"use strict";
import {http} from '../../../../core';
import Config from "../../../../app.config";
const RequestService = http.create();


export default {
    //事件细化统计
    //事件分类统计
    classifyStatistics(params){
        return  RequestService.get('event/classified_statistics',params)
    },
    //事件关闭分类统计
    eventCloseClassify(params){
        return RequestService.post(`event/event_close_classified_statistics?group=${params.group}&startTime=${params.startTime}&stopTime=${params.stopTime}`,params)
    },
    //事件关闭分类统计
    eventCloseClassifyGroup(params){
        return RequestService.get('event/event_close_classified_group_statistics',params)
    },


}
